import { createContext, useContext, useState } from "react";
import translations from "../translations/translations";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("IT");
  const t = translations[lang];
  const toggleLang = () => setLang((l) => (l === "IT" ? "EN" : "IT"));
  return (
    <LanguageContext.Provider value={{ lang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
